export default "__VITE_ASSET__vEv_vT5F__"